import styled, { css } from 'styled-components';

export const Img = styled.figure`
	position: relative;
	margin: 0;
	width: 100%;
	height: 130px;
	background-color: ${({ theme }) => theme.lightGrayColor};
	overflow: hidden;

	img {
		position: absolute;
		top: 50%;
		left: 50%;
		width: 100%;
		min-height: 100%;
		object-fit: cover;
		object-position: center;
		transform: translate(-50%, -50%);
	}

	@media (min-width: 993px) {
		width: ${({ $type }) => $type === 'wide' && '50%'};
		height: ${({ $type }) => $type === 'wide' && '100%'};
	}
`;

export const Desc = styled.div`
	margin-top: 15px;
	position: relative;
	box-sizing: border-box;
	overflow: hidden;
	max-height: 44px;
	color: ${({ theme }) => theme.primaryBlackColor};
	${({ theme }) => theme.typography.textBoldL};
`;

const WideInfo = css`
	position: relative;
	width: ${({ $noImage }) => ($noImage ? '100%' : '50%')};
	max-height: 100%;
	min-height: 100%;
	display: inline-block;
	vertical-align: top;
	padding: 20px 24px;
	overflow: hidden;
	background-color: #fff;

	&::before {
		content: '';
		display: block;
		position: absolute;
		width: 100%;
		height: 55px;
		bottom: 0;
		left: 0;
		background: -moz-linear-gradient(top, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 1) 100%);
		background: -webkit-linear-gradient(top, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 1) 100%);
		background: linear-gradient(to bottom, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 1) 100%);
		filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#5cffffff', endColorstr='#ffffff',GradientType=0);
	}
`;

export const Info = styled.div`
	padding: 24px;
	text-align: left;
	box-sizing: border-box;
	display: flex;
	flex: 1;
	justify-content: space-between;
	flex-direction: column;

	${({ $isTitle, theme }) =>
		$isTitle &&
		`${Desc} {
		color: ${theme.primaryColor};
	}`};

	@media (min-width: 993px) {
		${({ $type }) => $type === 'wide' && WideInfo}
	}
`;

export const Top = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: baseline;
	color: ${({ theme }) => theme.darkGrayColor};
	font-weight: 300;
	margin-bottom: 13px;
`;

export const Label = styled.div`
	margin-bottom: 6px;
	color: ${({ theme }) => theme.darkGrayColor};
	${({ theme }) => theme.typography.textAccentXS};
`;

export const DateBlock = styled.div`
	font-size: 12px;
`;

export const Title = styled.div`
	position: relative;
	margin-bottom: auto;
	padding-right: 15px;
	padding-bottom: 5px;
	box-sizing: border-box;
	overflow: hidden;
	text-overflow: ellipsis;
	width: 100%;
	color: ${({ theme }) => theme.primaryBlackColor};
	${({ theme }) => theme.typography.textBoldL};
`;

export const Text = styled.div`
	line-height: 1.6;
	margin-top: 15px;
	color: ${({ theme }) => theme.primaryBlackColor};

	@media (max-width: 1250px) {
		margin-top: 3px;
	}
`;

export const Root = styled.section`
	width: 100%;
	border: 2px solid ${({ theme }) => theme.lightGrayColor};
	border-radius: 4px;
	box-sizing: border-box;
	font-size: 14px;
	transition: border 0.3s;
	position: relative;
	background: #fff;
	${({ $static }) => $static && 'height: 95%;'}
	${({ theme }) => theme.typography.textM};

	&:hover {
		box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
	}

	& > a,
	& > button {
		display: flex;
		text-decoration: none;
		flex-direction: column;
		width: 100%;
		height: 100%;
		border: none;
		box-shadow: none;
		background-color: transparent;
		padding: 0;
		margin: 0;
		cursor: pointer;
	}

	@media (min-width: 993px) {
		${({ $type }) => $type === 'wide' && 'grid-column: span 2;'}

		& > a, & > button {
			flex-direction: ${({ $type, $noImage }) => $type === 'wide' && !$noImage && 'row'};
		}
	}
`;
